export default "__VITE_ASSET__Bc9UqNrB__"